import _ from 'lodash';
import { AnyAction } from 'redux';
import { singleEntityDefaultState, SingleEntityState } from '../entities/types/SingleEntityState';
import {
    FAILURE_CREATE_DOWNLOAD,
    FAILURE_CREATE_DOWNLOAD_CATEGORY,
    FAILURE_CREATE_DOWNLOAD_LANGUAGE,
    FAILURE_DELETE_DOWNLOAD,
    FAILURE_DELETE_DOWNLOAD_CATEGORY,
    FAILURE_DELETE_DOWNLOAD_LANGUAGE,
    FAILURE_DOWNLOADS,
    FAILURE_DOWNLOAD_CATEGORIES,
    FAILURE_DOWNLOAD_LANGUAGE,
    FAILURE_EDIT_DOWNLOAD_CATEGORY,
    REQUEST_CREATE_DOWNLOAD,
    REQUEST_CREATE_DOWNLOAD_CATEGORY,
    REQUEST_CREATE_DOWNLOAD_LANGUAGE,
    REQUEST_DELETE_DOWNLOAD,
    REQUEST_DELETE_DOWNLOAD_CATEGORY,
    REQUEST_DELETE_DOWNLOAD_LANGUAGE,
    REQUEST_DOWNLOADS,
    REQUEST_DOWNLOAD_CATEGORIES,
    REQUEST_DOWNLOAD_LANGUAGE,
    REQUEST_EDIT_DOWNLOAD_CATEGORY,
    SUCCESS_CREATE_DOWNLOAD,
    SUCCESS_CREATE_DOWNLOAD_CATEGORY,
    SUCCESS_CREATE_DOWNLOAD_LANGUAGE,
    SUCCESS_DELETE_DOWNLOAD,
    SUCCESS_DELETE_DOWNLOAD_CATEGORY,
    SUCCESS_DELETE_DOWNLOAD_LANGUAGE,
    SUCCESS_DOWNLOADS,
    SUCCESS_DOWNLOAD_CATEGORIES,
    SUCCESS_DOWNLOAD_LANGUAGE,
    SUCCESS_EDIT_DOWNLOAD_CATEGORY,
} from './actions';

export function downloadCategoriesReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_DOWNLOAD_CATEGORIES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_DOWNLOAD_CATEGORIES: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_DOWNLOAD_CATEGORIES:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_CREATE_DOWNLOAD_CATEGORY:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CREATE_DOWNLOAD_CATEGORY: {
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        }
        case FAILURE_CREATE_DOWNLOAD_CATEGORY:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_EDIT_DOWNLOAD_CATEGORY:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_EDIT_DOWNLOAD_CATEGORY:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_EDIT_DOWNLOAD_CATEGORY:
            return _.assign({}, state, { isFetching: false, error: action.error });
        case REQUEST_DELETE_DOWNLOAD_CATEGORY:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_DELETE_DOWNLOAD_CATEGORY: {
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        }
        case FAILURE_DELETE_DOWNLOAD_CATEGORY:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

export function downloadReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_DOWNLOADS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_DOWNLOADS: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_DOWNLOADS:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_CREATE_DOWNLOAD:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CREATE_DOWNLOAD: {
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        }
        case FAILURE_CREATE_DOWNLOAD:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_DELETE_DOWNLOAD:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_DELETE_DOWNLOAD: {
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        }
        case FAILURE_DELETE_DOWNLOAD:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

export function downloadLanguageReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_DOWNLOAD_LANGUAGE:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_DOWNLOAD_LANGUAGE: {
            return _.assign({}, state, {
                isFetching: false,
                content: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_DOWNLOAD_LANGUAGE:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_CREATE_DOWNLOAD_LANGUAGE:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CREATE_DOWNLOAD_LANGUAGE: {
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        }
        case FAILURE_CREATE_DOWNLOAD_LANGUAGE:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_DELETE_DOWNLOAD_LANGUAGE:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_DELETE_DOWNLOAD_LANGUAGE: {
            return _.assign({}, state, {
                isFetching: false,
                error: undefined,
            });
        }
        case FAILURE_DELETE_DOWNLOAD_LANGUAGE:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}
